const getters = {
  users: state => state.users,
  users_paginate: state => state.users_paginate,
  user: state => state.user,
  trashedUsers: state => state.trashedUsers,
  usersNames: state => state.usersNames,
  transactions: state => state.transactions,
}
export default getters
